import React from 'react';
import { ChevronDown } from 'lucide-react';

const Hero = () => {
  const scrollToMenu = () => {
    const menuSection = document.getElementById('menu');
    if (menuSection) {
      menuSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section data-component-path="client/src/components/Hero.jsx" data-component-line="13:5" data-component-id="client/src/components/Hero.jsx:13:5" className="relative h-screen flex items-center justify-center overflow-hidden">
      <div data-component-path="client/src/components/Hero.jsx" data-component-line="14:7" data-component-id="client/src/components/Hero.jsx:14:7" 
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1554118811-1e0d58224f24?w=1920&q=80)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div data-component-path="client/src/components/Hero.jsx" data-component-line="22:9" data-component-id="client/src/components/Hero.jsx:22:9" className="absolute inset-0 bg-charcoal/60"></div>
      </div>

      <div data-component-path="client/src/components/Hero.jsx" data-component-line="25:7" data-component-id="client/src/components/Hero.jsx:25:7" className="relative z-10 text-center px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto">
        <h1 data-component-path="client/src/components/Hero.jsx" data-component-line="26:9" data-component-id="client/src/components/Hero.jsx:26:9" className="hero-title text-5xl sm:text-6xl md:text-7xl lg:text-8xl text-cream mb-6 animate-fade-in">
          The Ember & Oak
        </h1>
        <p data-component-path="client/src/components/Hero.jsx" data-component-line="29:9" data-component-id="client/src/components/Hero.jsx:29:9" className="text-xl sm:text-2xl md:text-3xl text-cream/90 mb-4 font-light">
          Artisanal Coffee • Wood-Fired Comfort • All-Day Dining
        </p>
        <p data-component-path="client/src/components/Hero.jsx" data-component-line="32:9" data-component-id="client/src/components/Hero.jsx:32:9" className="text-lg sm:text-xl text-cream/80 mb-12 max-w-3xl mx-auto">
          A modern, casual café-restaurant blending specialty coffee, wood-fired dishes, and a warm minimalist atmosphere
        </p>
        
        <div data-component-path="client/src/components/Hero.jsx" data-component-line="36:9" data-component-id="client/src/components/Hero.jsx:36:9" className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button data-component-path="client/src/components/Hero.jsx" data-component-line="37:11" data-component-id="client/src/components/Hero.jsx:37:11" 
            onClick={scrollToMenu}
            className="h-14 px-8 bg-copper text-white rounded-lg hover:bg-copper/90 transition-all duration-200 shadow-lg hover:shadow-xl flex items-center justify-center gap-2 focus:ring-4 focus:ring-copper/50 text-lg font-medium"
          >
            View Menu
          </button>
          <button data-component-path="client/src/components/Hero.jsx" data-component-line="44:11" data-component-id="client/src/components/Hero.jsx:44:11" 
            onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
            className="h-14 px-8 bg-white/10 backdrop-blur-sm text-cream border-2 border-cream/30 rounded-lg hover:bg-white/20 transition-all duration-200 shadow-lg hover:shadow-xl flex items-center justify-center gap-2 text-lg font-medium"
          >
            Reserve Table
          </button>
        </div>
      </div>

      <button data-component-path="client/src/components/Hero.jsx" data-component-line="53:7" data-component-id="client/src/components/Hero.jsx:53:7" 
        onClick={scrollToMenu}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 text-cream animate-bounce"
      >
        <ChevronDown data-component-path="client/src/components/Hero.jsx" data-component-line="57:9" data-component-id="client/src/components/Hero.jsx:57:9" className="w-8 h-8" />
      </button>
    </section>
  );
};

export default Hero;